export default "/images/pencil-square.svg?1bd74fe21bfba125243d0325c9300f0c";